import type { HttpErrorResponse } from '@angular/common/http';

import type { Company, CreateCompany } from '@core/company-types';
import { createSingleEntityStore } from '@core/ngrx-legacy';

const { actions, selectors, reducer, namespace } = createSingleEntityStore<Company | null>()(
  'company',
  {
    customActions: adapter => ({
      create: (state, payload: { body: CreateCompany; skipCompany?: boolean }) => state,
      createSuccess: (state, payload: Company) => state,
      createFailed: (state, payload: HttpErrorResponse) => state,

      leave: (state, payload: { id: Company['id'] }) => state,
      leaveSuccess: (state, payload: Company) => state,
      leaveFailed: (state, payload: HttpErrorResponse) => state,

      update: (state, payload: Partial<Company> & { secureChangeToken?: string }) =>
        adapter.markAsPending(state),
    }),
  },
);

const CompanyActions = <
  Pick<
    typeof actions,
    | 'update'
    | 'updateSuccess'
    | 'updateFailed'
    | 'create'
    | 'createSuccess'
    | 'createFailed'
    | 'leave'
    | 'leaveSuccess'
    | 'leaveFailed'
  >
>actions;

export {
  actions,
  CompanyActions,
  reducer as CompanyReducer,
  namespace as CompanyNamespace,
  selectors as CompanySelectors,
};
